import { ComponentProps } from 'react';

const BordExtraIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;

  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.4287 22.8467H15.4287M16.4287 15.9998H15.4287M16.4287 9.15283L15.4287 9.15283"
        stroke={stroke || "#070F21"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BordExtraIcon;